import {applyMiddleware, compose, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import {persistReducer, persistStore} from 'redux-persist'
import reducer from './redux/reducers';
import storage from 'redux-persist/lib/storage'


const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: ['cmEnums', 'shopingCart', 'tickets', 'loginByOauth','loginedUser','gpbyattds']
}
const persistedReducer = persistReducer(persistConfig, reducer)


const createStoreWithMiddleware = applyMiddleware(
    thunkMiddleware,
    promiseMiddleware({promiseTypeSuffixes: ['PENDING', 'SUCCESS', 'ERROR']})
)(createStore)


function configureStore(initialState) {
    let store;

    if (process.env.NODE_ENV === 'development') {
        const persistState = require('redux-devtools').persistState;
        const DevTools = require('./components/DevTools').default;

        const enhancer = compose(
            DevTools.instrument(),
            persistState(
                window.location.href.match(
                    /[?&]debug_session=([^&#]+)\b/
                )
            )
        );
        store = createStoreWithMiddleware(persistedReducer, initialState, enhancer);

        /* if (module.hot) {
             module.hot.accept('../reducers', () =>
                 store.replaceReducer(require('./redux/reducer').default)
             );
         }*/
    } else {
        store = createStoreWithMiddleware(persistedReducer, initialState);
    }

    const persistor = persistStore(store);

    return {store, persistor}
}

const {store, persistor} = configureStore();
export {store, persistor, persistConfig}


// WEBPACK FOOTER //
// ./src/store.js